import { arblanguage, englanguage } from "./type"

export const lan=(e)=>{
    return{
        type:e
    }
}
